<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="section">
      <div class="columns">
        <div class="column is-3"></div>
        <div class="column is-5">Frame No: <input type="text" class="input" name="frameNo" v-model="frameNo" style="width:80%"></div>
        <div class="column is-1"><button  class="button is-danger" id="submit-button" name="submit-button" v-on:click="searchCar" >Search</button></div>
      </div>
      <div class="container">
          <span v-show="!dataAlready && startSearch">Loading....</span>
          <table class="table is-striped" style="width:100%" v-show="dataAlready">
              <thead>
                  <tr>
                    <th><abbr title="name">LINE User ID</abbr></th>
                    <th><abbr title="name">ชื่อลูกค้า</abbr></th>
                    <th><abbr title="licenseNo">เลขทะเบียน</abbr></th>
                    <th><abbr title="userId">เลขเฟรม</abbr></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="car in carList">
                  <tr v-bind:key="car.id" v-if="car.userId != '' && car.userId != '-1' ">
                    <td>{{car.userId}}</td>
                    <td>{{car.customerName}}</td>
                    <td>{{car.licenseNo}}</td>
                    <td>{{car.frameNo}}</td>
                  </tr>
                </template>
              </tbody>
          </table>
      </div>
    </section>
  </div>

</template>
<style scoped>
.banner {
  text-align: center;
  background-color: #000;
}
.hero-body {
  padding: 1.5rem 1.5rem !important;
}
.section {
  padding: 1rem .2rem !important;
}
.txt_small {
  font-size: 10px;
}
.section_form {
  width: 400px;
  margin: 0 auto;
}
</style>
<script>
export default {
  name: 'Home',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {},
  data: () => ({
    dataAlready: false,
    startSearch: false,
    saving: false,
    carId: '',
    carList: [],
    frameNo: ''
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  methods: {
    searchCar () {
      let _this = this
      _this.startSearch = true
      _this.dataAlready = false
      this.$axios
        .get(`${this.$apiUrl}getCarByFrameNo?frameNo=${_this.frameNo}`)
        .then(response => {
          _this.startSearch = false
          _this.dataAlready = true
          _this.carList = response.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue